import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import type { DbAppSubscription } from '@/shared/typings/types/subscription';

type AppState = {
  subscription?: DbAppSubscription;
  subscriptionHasInit: boolean;
  disabled: boolean;
  features: string[];
  _init: boolean;
};

const initialState: AppState = {
  subscriptionHasInit: false,
  disabled: false,
  features: [],
  _init: false,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppSubscription(state, { payload }: PayloadAction<DbAppSubscription | undefined>) {
      state.subscription = payload;
      state.subscriptionHasInit = true;
      state.features = [...(payload?.appFeatures ?? []), ...(payload?.privateFeatures ?? [])];
      state._init = true;
    },
  },
});

export const {
  setAppSubscription,
} = appSlice.actions;

export const getAppSubscription = (state: RootState): DbAppSubscription | undefined => state.app.subscription;
export const getSubscriptionHasInit = (state: RootState): boolean => state.app.subscriptionHasInit;

export default appSlice.reducer;
